import React from "react";
import { Col, Row } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import ChoiceInput from "../../choiceInput";
import ReactTooltip from "react-tooltip";

interface Props {
  enableUseCharityLogo: boolean;
  updateEnableUseCharityLogo: () => void;
}

class UseCharityLogoCheckbox extends React.PureComponent<Props> {
  static defaultProps = {
    enableUseCharityLogo: false,
  };

  render() {
    return (
      <Col className={s.content} md={12} sm={12}>
        <Row>
          <ChoiceInput
            title={"Use Charity Logo "}
            checked={this.props.enableUseCharityLogo}
            onChangeHandler={this.props.updateEnableUseCharityLogo}
            id={
              "enableUseCharityLogo" +
              (this.props.enableUseCharityLogo ? "_checked" : "_unchecked")
            }
            showInfo={true}
            infoId={"UseCharityLogoOption"}
          />
          <ReactTooltip
            id={`tpUseCharityLogoOption`}
            type="info"
            place="top"
            effect="float"
          >
            Use the charity logo in emails and MMS notifications. Media will not
            be required.
          </ReactTooltip>
        </Row>
      </Col>
    );
  }
}

export default withStyles(s)(UseCharityLogoCheckbox);
